import { REGIONS } from "@/data/content";
import { useReducedMotion } from "framer-motion";

// Minimal, original Asia map: abstract dotted landmass with node markers.
export function AsiaMap() {
  const reduce = useReducedMotion();
  return (
    <div className="relative w-full" data-testid="asia-map">
      <svg viewBox="0 0 520 420" className="w-full h-auto" role="img" aria-label="ThinkStack presence across Asia, headquartered in Singapore">
        <defs>
          <pattern id="dots" width="9" height="9" patternUnits="userSpaceOnUse">
            <circle cx="1.4" cy="1.4" r="1.1" fill="#0A192F" opacity="0.12" />
          </pattern>
        </defs>
        {/* abstract landmass silhouette (stylised, not geographically precise) */}
        <path
          d="M120,120 C160,80 240,70 300,90 C360,60 430,80 460,130 C480,170 440,190 430,150 C420,200 470,230 440,270 C410,300 380,270 360,300 C340,340 300,380 250,360 C200,380 150,350 140,300 C110,300 90,260 110,220 C90,190 100,150 120,120 Z"
          fill="url(#dots)"
          stroke="#E5E5E5"
          strokeWidth="1"
        />
        {REGIONS.map((r, i) => {
          const isHQ = r.note === "Headquarters";
          return (
            <g key={r.name}>
              {isHQ && (
                <circle cx={r.x} cy={r.y} r="12" fill="none" stroke="#2B5A8F" strokeWidth="1" opacity="0.5">
                  {!reduce && (
                    <animate attributeName="r" values="6;16;6" dur="3s" repeatCount="indefinite" />
                  )}
                </circle>
              )}
              <circle cx={r.x} cy={r.y} r={isHQ ? 4.5 : 3} fill={isHQ ? "#2B5A8F" : "#0A192F"} />
              <text x={r.x + 8} y={r.y + 3} fontSize="9" fill="#4A4A4A" fontFamily="IBM Plex Mono, monospace">
                {r.name}{isHQ ? " ·" : ""}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
